module.exports = __webpack_public_path__ + "img/ty2.74c841ce.png";